import React, { useState } from "react";
import Iframe from "react-iframe";
import { InlineMath } from "react-katex";

const Cb2 = () => {
	const [show, setShow] = useState(false);
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);

	const [form1, setForm1] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form2, setForm2] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form3, setForm3] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form4, setForm4] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form5, setForm5] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form6, setForm6] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form7, setForm7] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form8, setForm8] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow2(true);
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "8") {
			setShow(true);
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setShow3(true);
			setForm3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow1(true);
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4,0") {
			setShow4(true);
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,8") {
			setShow5(true);
			setForm6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5,0") {
			setShow6(true);
			setForm7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,4") {
			setShow7(true);
			setForm8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	return (
		<div className="container mt-2">
			<div className="text-center">
				Gambarlah daerah penyelesaian dari suatu sistem pertidaksamaan linear
				dua variabel di bawah ini !
			</div>

			<div className="text-center">
				<InlineMath math="2x + y ≤ 8 ; " />{" "}
				<InlineMath math=" 4x + 5y ≤ 20; " />
			</div>
			<ul style={{ width: "80%", margin: "auto" }}>
			<li>
				Pada  <InlineMath math="2x + y = 8 \space" />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>:
				</li>

				<div className="d-flex justify-content-center">
					<table
						style={{
							border: "2px solid green",
							borderCollapse: "collapse",
							width: "30%",
							textAlign: "center",
							marginBottom: "1rem",
						}}
					>
						<tr>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>x</i>
							</th>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<input style={form1} onChange={handleform1} type="text" />
							</th>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>0</i>
							</th>
						</tr>
						<tr>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>y</i>
							</td>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>0</i>
							</td>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<input style={form2} onChange={handleform2} type="text" />
							</td>
						</tr>
					</table>
				</div>
				{show&&show2 ? (
					<>
							<div className="d-flex justify-content-center">
							<p>
								Titik Koordinat A = (
								<input type="text" onChange={handleform5} style={form5} />)
							</p>
						</div>
						<div className="d-flex justify-content-center">
							<p>
								Titik Koordinat B = (
								<input type="text" onChange={handleform6} style={form6} />)
							</p>
						</div>
				{show4&&show5?
				<>
					<li>
				Pada <InlineMath math=" 4x + 5y = 20 \space " />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>:
				</li>

<div className="d-flex justify-content-center">
	<table
		style={{
			border: "2px solid green",
			borderCollapse: "collapse",
			width: "30%",
			textAlign: "center",
			marginBottom: "1rem",
		}}
	>
		<tr>
			<th
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<i>x</i>
			</th>
			<th
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<input style={form3} onChange={handleform3} type="text" />
			</th>
			<th
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<i>0</i>
			</th>
		</tr>
		<tr>
			<td
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<i>y</i>
			</td>
			<td
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<i>0</i>
			</td>
			<td
				style={{
					border: "2px solid green",
					borderCollapse: "collapse",
				}}
			>
				<input style={form4} onChange={handleform4} type="text" />
			</td>
		</tr>
	</table>
</div>
{show1&&show3 ? (
	<>
					<div className="d-flex justify-content-center">
							<p>
								Titik Koordinat C = (
								<input type="text" onChange={handleform7} style={form7} />)
							</p>
						</div>
						<div className="d-flex justify-content-center">
							<p>
								Titik Koordinat D= (
								<input type="text" onChange={handleform8} style={form8} />)
							</p>
						</div>
	{show6&&show7?
	<>
		<p className="text-center alert alert-warning">
			Coba kamu kerjakan perintah yang ada pada grafik di bawah ini!
		</p>
		<div className="d-flex justify-content-center">
			<Iframe
scrolling="no" title="mmcb2sptldv" src="https://www.geogebra.org/material/iframe/id/tpjaudjw/width/900/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="900px" height="717px"
allowFullScreen />
		</div>
	</>
	:null}
	</>
) : null}
				</>
				:null}
					</>
				) : null}
			</ul>
		</div>
	);
};

export default Cb2;
